module.exports = __webpack_public_path__ + "51d11a72b39f33f909abddc723d66f03.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/KaushanScript-Regular.ttf
// module id = 359
// module chunks = 0